import { setupWorker } from 'msw';
import { handers } from '@/shared/mocks/handler';

export const worker = setupWorker(...handers);
